const BATCH_FROM_JOB_ID =
  /^upload-batch-([1-9]\d{0,18}|[a-fA-F0-9]{24})(?:-chunk-\d+)?$/i;

/**
 * Normalize a batch id from presign/complete/poll payloads.
 * BullMQ job ids look like `upload-batch-61` and must not be used as the API path.
 */
export function parseUploadBatchId(value) {
  if (value == null || value === "") return "";
  if (typeof value === "object") {
    if (value._id != null) return parseUploadBatchId(value._id);
    if (value.id != null && typeof value.id !== "function") {
      return parseUploadBatchId(value.id);
    }
  }
  const s = String(value).trim();
  const prefixed = BATCH_FROM_JOB_ID.exec(s);
  if (prefixed) return prefixed[1];
  return s;
}
